import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Nav, NavItem, Card } from "react-bootstrap";
import "./SideNavigation.css";

export default function SideNavigationMenu(props) {
  const activeStyle = { 
    backgroundColor: "#005867", 
    color: "white",
    borderRadius: "4px"
  };
  
  return (
    <div className="side-nav-container">
      {/* Main Header Stripe */}
      <div className="side-nav-main-header">
        <h4 className="main-header-title">Rev Share</h4>
      </div>
      
      {/* Main Navigation Section - without header */}
      <Card className="side-nav-card mb-3 mt-3">
        <Card.Body className="p-2">
          <Nav className="flex-column">
            <NavItem className="nav-item">
              <NavLink to="/revshare/dashboard" exact activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                Current Quarter
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/revshare/availablehours" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                My Hours
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/revshare/accounthistory" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                Transaction History
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/revshare/utilizationrequests" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                My Requests
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/revshare/frequentlyaskedquestions" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                Frequently Asked Questions
              </NavLink>
            </NavItem>
          </Nav>
        </Card.Body>
      </Card>

        {/* Manager Navigation Section - only visible for admins */}
        {props.isManager && (
        <Card className="side-nav-card mb-3">
          <div className="side-nav-section">
            <h5 className="side-nav-section-title">Management</h5>
          </div>
          <Card.Body className="p-2">
            <Nav className="flex-column">
              <NavItem className="nav-item">
                <NavLink 
                  to="/revshare/dashboard/manager" 
                  activeStyle={activeStyle} 
                  className="nav-link p-2 side-nav-link"
                >
                  Employee Lookup
                </NavLink>
              </NavItem>
            </Nav>
          </Card.Body>
        </Card>
      )}
      
      {/* Admin Navigation Section - only visible for admins */}
      {props.isAdmin && (
        <Card className="side-nav-card mb-3">
          <div className="side-nav-section">
            <h5 className="side-nav-section-title">Administration</h5>
          </div>
          <Card.Body className="p-2">
            <Nav className="flex-column">
              <NavItem className="nav-item">
                <NavLink 
                  to="/revshare/dashboard/admin" 
                  activeStyle={activeStyle} 
                  className="nav-link p-2 side-nav-link"
                >
                  Employee Lookup
                </NavLink>
              </NavItem>
            </Nav>
          </Card.Body>
        </Card>
      )}
    </div>
  );
}

SideNavigationMenu.propTypes = {
  isAdmin: PropTypes.bool,
  isManager: PropTypes.bool,
};